<mat-card class="mat-elevation-z0 custom">
    <mat-card-content>
        <div fxLayout="column" fxLayoutAlign="center center"> <span><a
                    href='https://planungsbuero-schulz.de/#kontakt-impressum' target="_blank">Impressum</a> | <a
                    href='https://planungsbuero-schulz.de/?page_id=286' target="_blank">Datenschutzerklärung</a></span>
        </div>
    </mat-card-content>
</mat-card>